<template>
  <aside
    class="
      tw-z-[100000]
      tw-rounded-xl
      tw-max-h-full
      tw-overflow-hidden
      tw-flex
      tw-flex-col
      tw-w-full
      tw-bg-primary
      md:tw-w-96
      tw-fixed tw-h-full
    "
    :class="modal ? 'tw-translate-x-0' : 'tw-translate-x-full'"
  >
    <div
      class="
        tw-flex-none
        header
        tw-relative
        tw-w-full
        tw-select-none
        tw-h-16
        tw-bg-primary
        tw-flex
        tw-justify-between
        tw-items-center
        tw-px-6
      "
    >
      <div class="tw-text-white tw-flex tw-gap-4">
        <!-- <button @click="onCloseModal">
          <svg
            class="tw-w-6 tw-h-6 active:tw-text-slate-300 tw-fill-current tw-text-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              d="M447.1 256C447.1 273.7 433.7 288 416 288H109.3l105.4 105.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H416C433.7 224 447.1 238.3 447.1 256z"
            />
          </svg>
        </button> -->
        <!-- <p class="tw-text-white tw-text-xl tw-font-bold">Villa Support</p> -->
        <p class="tw-text-white tw-text-xl tw-font-bold">Live chat</p>
      </div>
      <button
        @click="onCallToVilla"
        class="
          tw-rounded-full tw-p-2 tw-border-2
          active:tw-bg-white
          tw-fill-white
          active:tw-text-[#5c53a3]
          tw-fill-current
          md:tw-hidden
        "
      >
        <svg
          class="
            tw-w-5 tw-h-5 tw-text-white
            active:tw-text-primary
            tw-fill-current
          "
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z"
          />
        </svg>
      </button>
      <div
        class="
          tw-absolute
          tw-z-50
          tw-bottom-[-3rem]
          tw-w-full
          tw-flex
          tw-flex-row
          tw-justify-center
          tw-gap-2
        "
        v-if="loading"
      >
        <p class="tw-text-slate-600 tw-self-center" v-if="loadingText">
          {{ loadingText }}
        </p>
        <svg
          role="status"
          class="
            tw-w-8 tw-self-center tw-h-8 tw-text-gray-200 tw-animate-spin
            tw-dark:text-gray-600
            tw-fill-[#2c2a74]
          "
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
      </div>
    </div>
    <!-- <div
      v-if="stateIndex >= 0"
      class="overay tw-absolute tw-z-50 tw-w-full tw-h-min tw-bg-black tw-bg-opacity-10 tw-text-center tw-mt-16 tw-flex tw-justify-center tw-items-center"
    >
      <p class="tw-text-slate-700 tw-text-lg tw-my-2">{{ overay[stateIndex].text }}</p>
    </div> -->
    <div
      class="
        rooms
        tw-bg-white
        tw-min-h-0
        tw-h-full
        tw-flex-auto
        tw-flex
        tw-flex-col
        tw-rounded-xl
        tw-m-2
        tw-mt-0
        tw-border-0
        tw-border-[#2c2a74]
        tw-p-2
      "
    >
      <div
        class="
          message
          tw-p-4
          tw-px-2
          tw-pt-0
          tw-mb-2
          tw-flex-auto
          tw-flex
          tw-flex-col-reverse
          tw-gap-1
          tw-overflow-y-auto
          tw-h-full
        "
        @scroll.passive="handleScroll"
      >
        <ChatMessage
          class="tw-mt-1 tw-flex-none last:tw-mt-8"
          v-for="message in messages"
          :key="message.Attributes"
          :message="message"
        ></ChatMessage>
      </div>
      <div v-if="chatBotMessage" class="tw-w-full tw-h-[8rem]"></div>
      <div
        class="
          tw-flex-none
          tw-relative
          tw-my-0
          tw-bg-slate-100
          tw-rounded-lg
          tw-overflow
          tw-h-fit
          tw-py-2
          tw-flex-col
          chat-input
          tw-h-aut tw-gap-2
        "
      >
        <ChatBotButton
          v-if="chatBotMessage"
          :message="chatBotMessage"
          @on-click-message="sendChatBotMessage"
          class="tw-absolute tw-bottom-[6.5rem] tw-right-0"
        />
        <div
          class="
            action
            tw-flex-none tw-flex tw-justify-start tw-w-full tw-px-2 tw-h-8
          "
        >
          <input
            ref="inputImageFile"
            type="file"
            multiple
            hidden
            accept="image/*"
            @change="onFileChange"
          />
          <button @click.prevent="onUploadFile">
            <svg
              class="
                image-upload-btn
                tw-w-6 tw-h-6 tw-text-slate-400 tw-fill-current
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                d="M447.1 32h-384C28.64 32-.0091 60.65-.0091 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96C511.1 60.65 483.3 32 447.1 32zM111.1 96c26.51 0 48 21.49 48 48S138.5 192 111.1 192s-48-21.49-48-48S85.48 96 111.1 96zM446.1 407.6C443.3 412.8 437.9 416 432 416H82.01c-6.021 0-11.53-3.379-14.26-8.75c-2.73-5.367-2.215-11.81 1.334-16.68l70-96C142.1 290.4 146.9 288 152 288s9.916 2.441 12.93 6.574l32.46 44.51l93.3-139.1C293.7 194.7 298.7 192 304 192s10.35 2.672 13.31 7.125l128 192C448.6 396 448.9 402.3 446.1 407.6z"
              />
            </svg>
          </button>
          <emoji-picker @emoji="append" :search="search">
            <button
              class="emoji-invoker"
              slot="emoji-invoker"
              slot-scope="{ events: { click: clickEvent } }"
              @click.stop="clickEvent"
            >
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current text-grey"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                />
              </svg>
            </button>
            <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
              <div
                class="emoji-picker"
                :style="{ top: display.y + 'px', left: display.x + 'px' }"
              >
                <div class="emoji-picker__search">
                  <input type="text" v-model="search" v-focus />
                </div>
                <div>
                  <div v-for="(emojiGroup, category) in emojis" :key="category">
                    <h5>{{ category }}</h5>
                    <div class="emojis">
                      <span
                        v-for="(emoji, emojiName) in emojiGroup"
                        :key="emojiName"
                        @click="insert(emoji)"
                        :title="emojiName"
                        >{{ emoji }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </emoji-picker>
        </div>
        <div
          v-if="preview.length > 0"
          ref="preview"
          class="
            preview
            tw-px-2
            tw-h-12
            tw-w-full
            tw-flex
            tw-flex-row
            tw-overflow-auto
            tw-gap-2
          "
        >
          <img
            class="tw-border tw-border-slate-400"
            v-for="(url, index) in preview"
            :key="index"
            :src="url"
            alt="preview img"
          />
        </div>
        <!-- <input
          class="
            tw-w-full tw-flex
            focus:tw-outline-none
            tw-bg-transparent tw-h-auto tw-px-2 tw-resize-none
            active:tw-border-none active:tw-outline-none
          "
          type="text"
          v-model.trim="input"
          @keyup.enter="onSendMessage"
        /> -->
        <textarea
          class="
            tw-bg-transparent tw-w-full tw-flex
            focus:tw-outline-none
            tw-h-auto tw-px-2 tw-resize-none
            active:tw-border-none active:tw-outline-none
          "
          v-model.trim="input"
          @keydown.enter.exact.prevent="onSendMessage"
        ></textarea>
        <div class="tw-flex-none tw-flex tw-justify-end tw-px-2 tw-gap-2">
          <p class="tw-text-slate-400">Press enter to send message</p>
          <button
            class="tw-right-2 tw-flex-none tw-bottom-2 tw-w-fit"
            @click="onSendMessage"
          >
            <svg
              class="
                tw-w-6 tw-h-6 tw-text-slate-400 tw-fill-current
                hover:tw-fill-slate-500
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M511.6 36.86l-64 415.1c-1.5 9.734-7.375 18.22-15.97 23.05c-4.844 2.719-10.27 4.097-15.68 4.097c-4.188 0-8.319-.8154-12.29-2.472l-122.6-51.1l-50.86 76.29C226.3 508.5 219.8 512 212.8 512C201.3 512 192 502.7 192 491.2v-96.18c0-7.115 2.372-14.03 6.742-19.64L416 96l-293.7 264.3L19.69 317.5C8.438 312.8 .8125 302.2 .0625 289.1s5.469-23.72 16.06-29.77l448-255.1c10.69-6.109 23.88-5.547 34 1.406S513.5 24.72 511.6 36.86z"
              />
            </svg>
          </button>
        </div>
        <!-- <div
          class="tw-left-2 tw--top-5 tw-absolute tw-text-xs tw-text-slate-400"
        >
          {{ typing | typingText }}
        </div> -->
      </div>
    </div>
  </aside>
</template>

<script>
/* eslint-disable @typescript-eslint/no-this-alias */

import dayjs from "dayjs";
import { debounce } from "debounce";
import { mapGetters } from "vuex";

import EmojiPicker from "vue-emoji-picker";

export default {
  name: "CustomerChat",
  props: ["modal"],
  components: {
    ChatMessage: () => import("./ChatMessage.vue"),
    ChatBotButton: () => import("./ChatBotButton.vue"),
    EmojiPicker,
  },
  data() {
    return {
      messages: [],
      nextToken: null,
      input: "",
      loading: false,
      roomLoaded: false,
      typing: {},
      files: [],
      preview: [],
      isGuestForm: false,
      loadingText: null,
      search: "",
    };
  },
  computed: {
    ...mapGetters({
      room: "customerChat/room",
      connected: "customerChat/connected",
      socket: "customerChat/socket",
      tempkey: "customerChat/tempkey",
      channel: "customerChat/channel",
    }),
    chatBotMessage() {
      const lastMessage = this.messages[0];
      if (lastMessage) {
        if (lastMessage.SenderID === "$chatbot") {
          return lastMessage;
        }
      }
      return null;
    },
  },
  async mounted() {
    const tempkey = this.$route.params["tempkey"];
    console.log(tempkey);
    if (tempkey) {
      this.$store.commit("customerChat/setTempkey", tempkey);
      const room = await this.$store.dispatch("customerChat/getRoom", tempkey);
      console.log(room);
      this.$store.commit("customerChat/setRoom", room);
      const mainParticipant = room.MainChannel.Participants || [];
      console.log(mainParticipant);
      const me = mainParticipant.find((p) => p.ID === p.RoomID);
      console.log(me);
      if (!me) {
        alert("Something went wrong. Please contact the seller.");
        return;
      }
      // Connect to websocket server
      await this.$store.dispatch("customerChat/connectWebSocket");
      // Load history message
      await this.fetchHistoryMessage();
      // Authorize to guest room

      //set ping interval
      if (!this.socket) {
        console.log("connect websocket");
        await this.$store.dispatch("customerChat/connectWebSocket");
      }
      const TOKEN = await this.$store.dispatch("customerChat/getToken");
      setInterval(() => {
        console.log("send ping");
        const body = {
          action: "ping",
          token: TOKEN,
        };
        this.socket.send(JSON.stringify(body));
      }, 1000 * 60 * 5);
    }
  },
  watch: {
    connected: {
      immediate: false,
      handler: async function (value) {
        console.log("connected watcher active", value);
        await this.$store.dispatch("customerChat/connectToLastRoom");
      },
    },
    input: {
      immediate: false,
      handler: debounce(
        async function () {
          if (!this.connected) console.log(this.rooms);
          this.$store.dispatch("customerChat/typing");
        },
        1000,
        true
      ),
    },
    socket: {
      handler: function () {
        let me = this;
        this.socket.addEventListener("message", async function (event) {
          const message = JSON.parse(event.data);
          console.log("Message from room socket ", message);
          if (message.Attributes === "Typing") {
            me.handlerTyping(message);
          } else {
            if (message.Type === "agent-assigned-notification") return;
            me.handlerMessage(message);
          }
        });
      },
    },
  },
  methods: {
    // async initialRoom() {
    //   if (this.rooms.length === 0) {
    //     if (this.user) {
    //       //Create room with auth user
    //       this.loading = true;
    //       this.loadingText = "Creating room";
    //       await this.$store.dispatch("customerChat/createRoom", {
    //         isGuest: false,
    //       });
    //       let me = this;
    //       setTimeout(async () => {
    //         await me.$store.dispatch("customerChat/fetchRooms");
    //         me.loadingText = null;
    //         me.loading = false;
    //       }, 5000);
    //     } else {
    //       const chatStruct = {
    //         Channel: this.channel,
    //         CreatedAt: dayjs(),
    //         ReadCount: 0,
    //         RoomID: this.selectedRoomID,
    //         SeenBy: null,
    //         SenderID: "$form",
    //         StickerID: "",
    //         Text: "Please type your name.",
    //         Type: "text",
    //         // NextEvent: value.NextEvent,
    //         // ForceReverse: true,
    //       };

    //       this.messages.splice(0, 0, chatStruct);
    //       this.isGuestForm = true;

    //       // await this.$store.dispatch("customerChat/createRoom", {
    //       //   name: this.input,
    //       //   isGuest: true,
    //       // });
    //     }
    //   }
    //   if (!this.socket) {
    //     console.log("connect websocket");
    //     await this.$store.dispatch("customerChat/connectWebSocket");
    //   }
    //   const TOKEN = await this.$store.dispatch("customerChat/getToken");
    //   setInterval(() => {
    //     console.log("send ping");
    //     const body = {
    //       action: "ping",
    //       token: TOKEN,
    //     };
    //     this.socket.send(JSON.stringify(body));
    //   }, 1000 * 60 * 5);
    // },
    onCloseModal() {
      this.$store.commit("customerChat/setModal", false);
    },
    // connectWebSocket() {
    //   const URL =
    //     "wss://6ek73q3k35.execute-api.ap-southeast-1.amazonaws.com/dev";

    //   this.socket = new WebSocket(URL);
    //   let me = this;

    //   this.socket.addEventListener("open", function (event) {
    //     console.log(event);
    //     me.socketConnected = true;
    //   });
    //   this.socket.addEventListener("message", async function (event) {
    //     const message = JSON.parse(event.data);
    //     console.log("Message from room socket ", message);
    //     if (message.Attributes === "Typing") {
    //       me.handlerTyping(message);
    //     } else {
    //       me.handlerChat(message);
    //     }
    //   });
    // },
    // handlerMessage(message) {
    //   console.log("handlerChat active");
    //   if (message.Channel === "main" && message.RoomID === this.tempkey) {
    //     console.log("main ch", message.SenderID, this.tempkey);
    //     if (
    //       message.SenderID === this.tempkey ||
    //       message.Attributes === this.messages[0].Attributes
    //     ) {
    //       console.log("same");
    //       this.messages.splice(0, 1, message);
    //     } else {
    //       // this.messages.splice(0, 0, message);
    //       // delete this.typing[message.SenderID];
    //       let index = this.messages.findIndex(
    //         (m) => m.Attributes === message.Attributes
    //       );
    //       console.log("found index", index);
    //       if (index >= 0) {
    //         this.messages[index] = Object.assign({}, message);
    //         delete this.typing[message.SenderID];
    //         return;
    //       }
    //       this.messages.splice(0, 0, message);
    //       delete this.typing[message.SenderID];
    //     }
    //   }
    // },
    handlerMessage(message) {
      const clone = this.messages;
      const foundIndex = clone.findIndex(
        (msg) => msg.Attributes === message.Attributes
      );
      if (foundIndex >= 0) {
        CloseEvent[foundIndex] = message;
      } else {
        clone.splice(0, 0, message);
      }
      this.message = clone;
    },
    handlerTyping(message) {
      console.log("handlerTyping active");
      // Filter message
      // if (message.Channel !== "main") return;
      if (message.RoomID !== this.selectedRoomID) {
        console.log(
          "fail cause: Same RoomID not match",
          message.RoomID,
          this.selectedRoomID
        );
      }
      if (message.CreatorID === this.senderID) {
        console.log(
          "fail cause: SenderID match",
          message.CreatorID && this.senderID
        );
      }

      console.log("handlerTyping customerChat", message);
      const now = dayjs();
      const myObj = {
        id: message.CreatorID,
        name: message.CreatorName,
        expireAt: now.add(5, "s"),
      };

      let typing = Object.assign({}, this.typing);
      typing[message.CreatorID] = myObj;

      this.typing = Object.assign({}, typing);
      setTimeout(() => {
        this.clearTyping();
      }, 5000);
      // console.log("nowww", this.typing[message.CreatorID]);
    },
    async fetchHistoryMessage() {
      const payload = {
        channel: "main",
      };
      const response = await this.$store.dispatch(
        "customerChat/getMessageByRoomID",
        payload
      );

      console.log("messages", response);
      this.messages = response.messages;
      this.nextToken = response.nextToken;
    },

    async fetchRoomsRetry() {
      var retries = 5;
      var success = false;

      while (retries > 0 && !success) {
        console.log("try count", retries);
        try {
          await this.$store.dispatch("customerChat/fetchRooms");
          success = true;
        } catch (error) {
          retries--;
        }
      }

      console.log(success);
    },

    async onSendMessage() {
      if (this.files.length > 0) {
        this.onSendImageMessage();
      }
      if (!this.input) return;
      const payload = {
        text: this.input,
      };

      this.input = null;

      const messageResponse = await this.$store.dispatch(
        "customerChat/addMessage",
        payload
      );
      if (messageResponse) {
        this.messages.splice(0, 0, messageResponse);
      }
    },
    async onSendImageMessage() {
      try {
        const files = this.files || [];
        console.log(files);
        let me = this;

        // files.forEach(async (f, index) => {
        //   const chatStruct = {
        //     Channel: this.channel,
        //     CreatedAt: dayjs(),
        //     ReadCount: 0,
        //     RoomID: this.tempkey,
        //     SeenBy: null,
        //     SenderID: this.tempkey,
        //     StickerID: "",
        //     Text: this.input,
        //     Type: "image",
        //     imageSrc: me.preview[index],
        //   };

        //   if (this.channel === "main") {
        //     this.messages.splice(0, 0, chatStruct);
        //   }
        // });

        await Promise.all([
          files.forEach(async (f) => {
            const imageMessageResponse = await me.$store.dispatch(
              "customerChat/addImageMessage",
              {
                file: f,
              }
            );
            console.log("image message response", imageMessageResponse);
            if (imageMessageResponse) {
              this.messages.splice(0, 0, imageMessageResponse);
            }
          }),
        ]);
        this.$refs.inputImageFile.values = [];
        this.files = [];
        this.preview = [];
      } catch (error) {
        console.error(error);
      }
    },
    onUploadFile() {
      console.log("upload file");
      this.$refs.inputImageFile.click();
    },
    onFileChange(e) {
      console.log("on file change");
      const files = e.target.files;
      console.log(files);
      this.files = Object.values(files) || [];

      if (this.files) {
        this.files.forEach((f) => {
          const reader = new FileReader();

          let me = this;
          reader.addEventListener(
            "load",
            function () {
              // convert image file to base64 string
              me.preview.push(reader.result);
            },
            false
          );
          reader.readAsDataURL(f);
        });
      }
    },
    handleScroll: debounce(function (event) {
      if (
        -event.srcElement.scrollTop + event.srcElement.clientHeight >=
        event.srcElement.scrollHeight - 10
      ) {
        this.onLoadMore();
      }
    }, 50),
    async onLoadMore() {
      console.log("onLoadmore");
      if (!this.nextToken) return;
      try {
        this.loading = true;
        const payload = {
          roomID: this.roomID,
          channel: this.channel,
          nextToken: this.nextToken,
          lastest: true,
        };
        const result = await this.$store.dispatch(
          "customerChat/getMessageByRoomID",
          payload
        );
        console.log(result);
        this.messages.push(...result.messages);
        this.nextToken = result.nextToken;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    clearTyping() {
      console.log("clear typing");
      const keys = Object.keys(this.typing);
      let clone = this.typing;
      keys.forEach((k) => {
        if (dayjs() > clone[k].expireAt) {
          delete clone[k];
        }
      });
      this.typing = Object.assign({}, clone);
    },
    onTapInput() {
      console.log("Tap Input");
      this.$nextTick(() => this.$refs.textInput.focus());
    },
    async sendChatBotMessage(value) {
      console.log(value);
      const payload = {
        text: value.Title,
        nextEvent: value.NextEvent,
      };

      let senderID;
      if (!this.user) {
        senderID = this.credential.identityId;
      } else {
        senderID = this.user.attributes.sub;
      }

      const chatStruct = {
        Channel: this.channel,
        CreatedAt: dayjs(),
        ReadCount: 0,
        RoomID: this.roomID,
        SeenBy: null,
        SenderID: senderID,
        StickerID: "",
        Text: value.Title,
        Type: "text",
        NextEvent: value.NextEvent,
      };

      if (this.channel === "main") {
        this.messages.splice(0, 0, chatStruct);
      }

      await this.$store.dispatch("customerChat/addMessage", payload);
    },
    onCallToVilla() {
      window.open("tel:+6627791000");
    },
    insert(emoji) {
      this.input += emoji;
    },
    append(emoji) {
      this.input += emoji;
    },
  },
  filters: {
    typingText(value) {
      // return value;
      let list = Object.values(value).filter((v) => dayjs() < v.expireAt);
      let text = "";
      if (list.length) {
        list.forEach((d, index) => {
          if (index === 0) {
            text = d.name;
          } else {
            text = text + ", " + d.name;
          }
        });
      }
      return text !== "" ? text + " typing..." : null;
    },
  },
};
</script>

<style>

/* * {
    border: 1px solid red;
} */

button {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rooms::-webkit-scrollbar,
.message::-webkit-scrollbar,
.note-list::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}
.rooms::-webkit-scrollbar-thumb,
.message::-webkit-scrollbar-thumb,
.note-list::-webkit-scrollbar-thumb {
  max-height: 10%;
  border-radius: 10px;
  background: #cbd5e1;
}

</style>

<style scoped>

.wrapper {
  position: relative;
  display: inline-block;
}

.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  background: transparent;
  border: 0;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  top: -330px !important;
  left: auto !important;
  right: 0 !important;
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 15rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}

</style>
